var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { attrs: { id: "example-scanning-overlay" } }, [
        _c("div", { staticClass: "inner" }, [
          _c("img", { attrs: { src: _vm.imgSrc } }),
          _vm._v(" "),
          _c("div", { staticClass: "scanline" }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a-scene",
        {
          attrs: {
            "mindar-image": {
              imageTargetSrc: _vm.mindSrc,
              uiScanning: "#example-scanning-overlay",
              uiError: "no",
              uiLoading: "no",
            },
            "color-space": "sRGB",
            renderer: "colorManagement: true, physicallyCorrectLights",
            "vr-mode-ui": "enabled: false",
            "device-orientation-permission-ui": "enabled: false",
          },
        },
        [
          _c(
            "a-assets",
            [
              _c("img", { attrs: { id: "card", src: _vm.imgSrc } }),
              _vm._v(" "),
              _c("a-asset-item", {
                attrs: {
                  id: "avatarModel",
                  src: "https://cdn.jsdelivr.net/gh/hiukim/mind-ar-js@1.2.5/examples/image-tracking/assets/card-example/softmind/scene.gltf",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-camera", {
            attrs: { position: "0 0 0", "look-controls": "enabled: false" },
          }),
          _vm._v(" "),
          _c(
            "a-entity",
            { attrs: { "mindar-image-target": "targetIndex: 0" } },
            [
              _c("a-plane", {
                attrs: {
                  src: "#card",
                  position: "0 0 0",
                  height: "0.552",
                  width: "1",
                  rotation: "0 0 0",
                },
              }),
              _vm._v(" "),
              _c("a-gltf-model", {
                attrs: {
                  rotation: "0 0 0 ",
                  position: "0 0 0.1",
                  scale: "0.005 0.005 0.005",
                  src: "#avatarModel",
                  animation:
                    "property: position; to: 0 0.1 0.1; dur: 1000; easing: easeInOutQuad; loop: true; dir: alternate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }